import { useSelector } from 'react-redux';

import { turboHelper } from 'business/order/geoqueue';
import type { OrderResponseFromStatusV2 } from 'business/shared/infra';
import { autoAcceptService } from 'features/settings-page/auto-accept';
import { useEffect, useState } from 'react';
import { ordersKanbanSelector } from '../../../redux/selectors/orders-kanban';
import { useCookingColumnLang } from './useCookingColumnLang';

export function useCookingColumn(hasAutoAccept: boolean) {
  const _ordersInCooking = useSelector(ordersKanbanSelector.inCooking);
  const _pendingOrders = useSelector(ordersKanbanSelector.pendingOrders);
  const text = useCookingColumnLang();
  const [ordersInCooking, setOrdersInCooking] = useState<
    OrderResponseFromStatusV2[]
  >([]);
  const [showEmptyTextOfOrders, setShowEmptyTextOfOrders] = useState<boolean>(
    true,
  );

  useEffect(() => {
    if (!!_ordersInCooking.length || !!_pendingOrders.length) {
      const updatedOrders = turboHelper.sortV2AutoacceptOrders([
        ..._sortedOrders(),
      ]);
      setOrdersInCooking(updatedOrders);
      setShowEmptyTextOfOrders(updatedOrders.length === 0);
    } else {
      setOrdersInCooking([]);
      setShowEmptyTextOfOrders(true);
    }
  }, [_ordersInCooking, _pendingOrders]);

  const _sortedOrders = () => {
    if (!hasAutoAccept) {
      return _ordersInCooking;
    }

    const autoAcceptNewOrders = autoAcceptService.filterCookingOrders(
      _ordersInCooking,
    );
    const highlightOrders = _pendingOrders
      .map(order => ({ ...order, isAutoAcceptNew: true }))
      .concat(
        autoAcceptNewOrders.map(order => ({
          ...order,
          isAutoAcceptNew: true,
        })),
      );
    const idsToExclude = new Set(autoAcceptNewOrders.map(order => order.id));
    const remainingOrders = _ordersInCooking.filter(
      order => !idsToExclude.has(order.id),
    );

    return [...highlightOrders, ...remainingOrders];
  };

  return {
    text,
    ordersInCooking,
    showEmptyTextOfOrders,
    numberOfOrdersInCooking: ordersInCooking.length,
  };
}
